import React from "react";
import { cn } from "../../utils/lib";

export function DriversIconSelected({ className, ...props }) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      className={cn("w-full h-auto", className)}
      {...props}
    >
      <path
        opacity="0.4"
        d="M7.50008 1.66602C5.31675 1.66602 3.54175 3.44102 3.54175 5.62435C3.54175 7.76602 5.21675 9.49935 7.40008 9.57435C7.46675 9.56602 7.53341 9.56602 7.58341 9.57435C7.60008 9.57435 7.60841 9.57435 7.62508 9.57435C7.63341 9.57435 7.63341 9.57435 7.64175 9.57435C9.77508 9.49935 11.4501 7.76602 11.4584 5.62435C11.4584 3.44102 9.68341 1.66602 7.50008 1.66602Z"
        fill="white"
      />
      <path
        d="M11.7333 11.7914C9.4083 10.2414 5.61663 10.2414 3.27497 11.7914C2.21663 12.4997 1.6333 13.4581 1.6333 14.4831C1.6333 15.5081 2.21663 16.4581 3.26663 17.1581C4.4333 17.9414 5.96663 18.3331 7.49997 18.3331C9.0333 18.3331 10.5666 17.9414 11.7333 17.1581C12.7833 16.4497 13.3666 15.4997 13.3666 14.4664C13.3583 13.4414 12.7833 12.4914 11.7333 11.7914Z"
        fill="white"
      />
      <path
        opacity="0.4"
        d="M16.6583 6.11708C16.7916 7.73374 15.6416 9.15041 14.05 9.34208C14.0416 9.34208 14.0416 9.34208 14.0333 9.34208H14.0083C13.9583 9.34208 13.9083 9.34207 13.8666 9.35874C13.0583 9.40041 12.3166 9.14207 11.7583 8.66707C12.6166 7.90041 13.1083 6.75041 13.0083 5.50041C12.95 4.82541 12.7166 4.20874 12.3666 3.68374C12.6833 3.52541 13.05 3.42541 13.425 3.39208C15.0583 3.25041 16.5166 4.46708 16.6583 6.11708Z"
        fill="white"
      />
      <path
        d="M18.3251 13.8247C18.2584 14.633 17.7418 15.333 16.8751 15.808C16.0418 16.2663 14.9918 16.483 13.9501 16.458C14.5501 15.9163 14.9001 15.2413 14.9668 14.5247C15.0501 13.4913 14.5584 12.4997 13.5751 11.708C13.0168 11.2663 12.3668 10.9163 11.6584 10.658C13.5001 10.1247 15.8168 10.483 17.2418 11.633C18.0084 12.2497 18.4001 13.0247 18.3251 13.8247Z"
        fill="white"
      />
    </svg>
  );
}
